<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      heartbeatInterval: null, // Para almacenar el ID del intervalo del latido
    };
  },
  methods: {
    /**
     * Envía una pequeña petición al backend para actualizar la última conexión del usuario.
     * Incluye el token JWT en el encabezado de autorización.
     */
    async sendHeartbeat() {
      const token = localStorage.getItem('token'); // Obtiene el token JWT del almacenamiento local
      const usuarioInfo = JSON.parse(localStorage.getItem('usuario')); // Obtiene la información del usuario
      const userId = usuarioInfo ? usuarioInfo.id : null; // Extrae el ID del usuario

      // Si no hay token o ID de usuario, significa que el usuario no está logueado o la sesión expiró.
      // Detenemos el latido y salimos de la función.
      if (!token || !userId) {
        this.stopHeartbeat();
        console.warn("Heartbeat detenido: Usuario no autenticado o token/ID faltante."); // eslint-disable-line no-console
        return;
      }

      try {
        // Realiza la petición POST al endpoint de actualización de actividad en tu backend PHP.
        // Asegúrate de que esta URL sea la correcta para tu script 'actualizar_actividad.php'.
        const response = await fetch('http://localhost/kqlurhnh_conciliacion/api/actualizar_actividad.php', {
          method: 'POST', // Método POST para enviar el token de forma segura en los headers
          headers: {
            'Content-Type': 'application/json', // Indica que el cuerpo de la petición es JSON (aunque vacío aquí)
            'Authorization': `Bearer ${token}` // Envía el token JWT en el formato 'Bearer'
          }
        });

        const data = await response.json(); // Parsea la respuesta JSON del servidor

        // Si la respuesta no fue exitosa (código de estado HTTP 2xx), maneja el error.
        if (!response.ok) {
          console.error('Error en latido:', data.message || 'Error desconocido.'); // eslint-disable-line no-console
          // Si el servidor indica que el token es inválido o expiró (ej. status 401),
          // podrías considerar forzar el cierre de sesión en el frontend.
          if (response.status === 401) {
            console.warn("Token expirado o inválido. Redirigiendo al login..."); // eslint-disable-line no-console
            // Aquí podrías limpiar localStorage y redirigir al login
            // localStorage.removeItem('token');
            // localStorage.removeItem('usuario');
            // this.$router.push('/login'); // Descomenta si usas Vue Router y quieres redirigir
            this.stopHeartbeat(); // Detén el latido si el token es inválido
          }
        } else {
          // console.log('Latido enviado exitosamente:', data.message); // Para depuración
        }
      } catch (error) {
        // Captura cualquier error de red o de la petición fetch
        console.error('Error al enviar latido (catch):', error); // eslint-disable-line no-console
      }
    },

    /**
     * Inicia el intervalo para enviar latidos periódicamente.
     * Limpia cualquier intervalo anterior para evitar duplicados.
     */
    startHeartbeat() {
      // Si ya hay un intervalo en ejecución, lo limpiamos para evitar múltiples latidos.
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
      }
      // Establece un nuevo intervalo para llamar a sendHeartbeat cada 60 segundos (60000 ms).
      // Puedes ajustar este valor si necesitas una detección de actividad más o menos frecuente.
      this.heartbeatInterval = setInterval(this.sendHeartbeat, 60000);
      // Envía el primer latido inmediatamente al iniciar el intervalo para registrar la actividad inicial.
      this.sendHeartbeat();
      console.log("Heartbeat iniciado."); // eslint-disable-line no-console
    },

    /**
     * Detiene el intervalo del latido, liberando recursos.
     */
    stopHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
        console.log("Heartbeat detenido."); // eslint-disable-line no-console
      }
    }
  },
  mounted() {
    // Cuando el componente App.vue se monta (es decir, cuando la aplicación se carga),
    // verificamos si el usuario está autenticado (tiene un token y datos de usuario en localStorage).
    // Si lo está, iniciamos el mecanismo de latido.
    if (localStorage.getItem('token') && localStorage.getItem('usuario')) {
      this.startHeartbeat();
    }
  },
  beforeUnmount() {
    // Este hook se ejecuta justo antes de que el componente sea desmontado (ej. si el usuario cierra la pestaña).
    // Es crucial detener el intervalo aquí para evitar fugas de memoria y que el latido siga intentando enviarse.
    this.stopHeartbeat();
  },
  // Opcional: Puedes añadir un watcher si el estado de autenticación cambia dinámicamente
  // (ej. si usas Vuex/Pinia para manejar el estado de autenticación y este se actualiza).
  // watch: {
  //   '$store.state.auth.isAuthenticated': function(newVal) { // Ejemplo si usas Vuex/Pinia
  //     if (newVal) {
  //       this.startHeartbeat();
  //     } else {
  //       this.stopHeartbeat();
  //     }
  //   }
  // }
};
</script>

<style>
/* Tus estilos globales de App.vue aquí */
</style>
